import { StringColumn, BooleanColumn } from 'baseui/data-table';
import { EMPTY_STRING } from 'commons-ui';
import moment from 'moment';

const convertEpochToDateTimeIST = (epochTime: number): string => {
	return moment
		.unix(epochTime / 1000)
		.utcOffset('+05:30')
		.format('DD/MM/YYYY HH:mm:ss');
};

export const COL_NAMES = {
	invoiceType: 'invoiceType',
	tournamentId: 'ltid',
	userId: 'zupeeUserId',
	email: 'email',
	isMTTTournament: 'isMTT',
	userName: 'name',
	userPhoneNumber: 'phone',
	tournamentRegistrationTime: 'registeredOn',
	paymentTime: 'paymentOn',
	entryFee: 'entryFee',
	transactionId: 'tid',
	tournamentName: 'tournamentName',
	url: 'url',
	invoiceCreatedAt: 'createdAt',
	// TAX
	CGST: 'cgst',
	taxableCGSTAmount: 'taxableCGSTAmount',
	SGST: 'sgst',
	taxableSGSTAmount: 'taxableSGSTAmount',
	IGST: 'igst',
	taxableIGSTAmount: 'taxableIGSTAmount',
	taxableAmount: 'taxableAmount',
	totalAmount: 'totalAmount',
	platformFee: 'platformFee',
	taxInvoiceId: 'taxInvoiceId',
	bonusMoneyUsed: 'bonusMoney',
	cashbackMoneyUsed: 'showCashbackMoney',
	// Acknowledgement
	acknowledgmentId: 'acknowledgmentId',
	// Credit
	creditNoteId: 'creditNoteId',
	refundedOn: 'refundedOn',
	// refund
	receiptId: 'receiptId',
	invoiceId: 'invoiceId',
	invoiceDate: 'invoiceDate',
	quizUserId: 'uid',
	tid: 'tid',
	safetyPackFee: 'safetyPackFee',
	insurancePackCode: 'insurancePackCode',
	userPayAmount: 'userPayAmount',
	userReceivedAmount: 'userReceivedAmount'
};

export const columnConfigs = [
	StringColumn({
		title: 'User ID',
		mapDataToValue: (data: any) => data[COL_NAMES.userId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Invoice Type',
		mapDataToValue: (data: any) => data[COL_NAMES.invoiceType] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Email',
		mapDataToValue: (data: any) => data[COL_NAMES.email] || EMPTY_STRING
	}),
	StringColumn({
		title: 'User Name',
		mapDataToValue: (data: any) => data[COL_NAMES.userName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'User Phone Number',
		mapDataToValue: (data: any) => data[COL_NAMES.userPhoneNumber] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Invoice Created At Date/Time',
		mapDataToValue: (data: any) =>
			data[COL_NAMES.invoiceCreatedAt] ? convertEpochToDateTimeIST(Number(data[COL_NAMES.invoiceCreatedAt])) : EMPTY_STRING
	}),
	StringColumn({
		title: 'Payment Date/Time',
		mapDataToValue: (data: any) =>
			data[COL_NAMES.paymentTime] ? convertEpochToDateTimeIST(Number(data[COL_NAMES.paymentTime])) : EMPTY_STRING
	})
];

export const columnConfigsPostDeposit = [
	...columnConfigs,
	StringColumn({
		title: 'IGST',
		mapDataToValue: (data: any) => data[COL_NAMES.IGST] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Taxable IGST Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.taxableIGSTAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Invoice ID',
		mapDataToValue: (data: any) => data[COL_NAMES.taxInvoiceId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'CGST',
		mapDataToValue: (data: any) => data[COL_NAMES.CGST] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Taxable CGST Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.taxableCGSTAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'SGST',
		mapDataToValue: (data: any) => data[COL_NAMES.SGST] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Taxable SGST Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.taxableSGSTAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'User Payed Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.userPayAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'User Received Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.userReceivedAmount] || EMPTY_STRING
	})
];

export const columnConfigsPreGst = [
	BooleanColumn({
		title: 'Is MTT tournament',
		mapDataToValue: (data: any) => data[COL_NAMES.isMTTTournament] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Tournament Registration Date/Time',
		mapDataToValue: (data: any) =>
			data[COL_NAMES.tournamentRegistrationTime]
				? convertEpochToDateTimeIST(Number(data[COL_NAMES.tournamentRegistrationTime]))
				: EMPTY_STRING
	}),
	StringColumn({
		title: 'Entry Fee',
		mapDataToValue: (data: any) => data[COL_NAMES.entryFee] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Transaction ID',
		mapDataToValue: (data: any) => data[COL_NAMES.transactionId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Tournament Name',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Tournament ID',
		mapDataToValue: (data: any) => data[COL_NAMES.tournamentId] || EMPTY_STRING
	})
];

export const columnConfigsTax = [
	...columnConfigs,
	...columnConfigsPreGst,
	StringColumn({
		title: 'Bonus Money Used',
		mapDataToValue: (data: any) => data[COL_NAMES.bonusMoneyUsed] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Cashback Money Used',
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackMoneyUsed] || EMPTY_STRING
	}),
	StringColumn({
		title: 'CGST',
		mapDataToValue: (data: any) => data[COL_NAMES.CGST] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Taxable CGST Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.taxableCGSTAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'SGST',
		mapDataToValue: (data: any) => data[COL_NAMES.SGST] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Taxable SGST Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.taxableSGSTAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Taxable Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.taxableAmount] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Platform Fee',
		mapDataToValue: (data: any) => data[COL_NAMES.platformFee] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Invoice ID',
		mapDataToValue: (data: any) => data[COL_NAMES.taxInvoiceId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Total Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.totalAmount] || EMPTY_STRING
	})
];

export const columnConfigsAck = [
	...columnConfigs,
	...columnConfigsPreGst,
	StringColumn({
		title: 'Acknowledgment Id',
		mapDataToValue: (data: any) => data[COL_NAMES.acknowledgmentId] || EMPTY_STRING
	})
];

export const columnConfigsCredit = [
	...columnConfigs,
	...columnConfigsTax,
	...columnConfigsPreGst,
	StringColumn({
		title: 'Credit Note Id',
		mapDataToValue: (data: any) => data[COL_NAMES.creditNoteId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Refunded On',
		mapDataToValue: (data: any) => data[COL_NAMES.refundedOn] || EMPTY_STRING
	})
];

export const columnConfigsRefund = [
	...columnConfigs,
	...columnConfigsPreGst,
	StringColumn({
		title: 'Receipt Id',
		mapDataToValue: (data: any) => data[COL_NAMES.receiptId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Refunded On',
		mapDataToValue: (data: any) => data[COL_NAMES.refundedOn] || EMPTY_STRING
	})
];

export const columnConfigQuizTax = [
	...columnConfigsTax,
	...columnConfigsPreGst,
	StringColumn({
		title: 'Invoice Id',
		mapDataToValue: (data: any) => data[COL_NAMES.invoiceId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Invoice Date',
		mapDataToValue: (data: any) => data[COL_NAMES.invoiceDate] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Quiz User Id',
		mapDataToValue: (data: any) => data[COL_NAMES.quizUserId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Transaction Id',
		mapDataToValue: (data: any) => data[COL_NAMES.tid] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Saftey Pack Fee',
		mapDataToValue: (data: any) => data[COL_NAMES.safetyPackFee] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Insurance Pack Code',
		mapDataToValue: (data: any) => data[COL_NAMES.insurancePackCode] || EMPTY_STRING
	})
];
